import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { BrokerService } from '@c4/core';

import { Room, MediaProgrammingContext } from '../quickstart-media.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { ItemsState } from '../../../common/services/items.service';

@Component({
  templateUrl: './select-room.component.html',
  styleUrls: ['../../../common/assets/styles/common.less']
})
export class QSMediaSelectRoomComponent extends BaseRoutingComponent {

  private _source: Observable<string>;
  private _rooms: Observable<Room[]>;

  constructor(
    private _route: ActivatedRoute,
    protected store: Store<{
      mediaProgramming: MediaProgrammingContext,
      programmingItems: ItemsState
    }>,
    private _broker: BrokerService,
    protected router: Router
  ) {
    super();

    this._source = this._route.params.map((params: { source: string }) => params.source);

    this._rooms = Observable.combineLatest(
      this._source,
      this.store.select(s => s.programmingItems.itemsList)
        .filter(i => !!i)
        .map(items => {
          let rooms = items.filter(item => item.type === 8);
          console.log('select-room(media): filtering for rooms', rooms);
          return rooms
        })
    ).flatMap(([source, rooms]) => {
      let deviceClass: string;

      switch (source) {
        case "broadcast_video":
        case "movie":
          deviceClass = 'watch_devices';
          break;

        case "broadcast_audio":
        case "album":
        case "playlist":
          deviceClass = 'listen_devices'
          break;
      }

      return Observable.fromPromise(this._broker.call({
        path: '/api/v1/locations/rooms/' + deviceClass
      })).map(response => {
        return rooms.filter(room => {
          let devices = response
            .find(r => r.id == room.id)[deviceClass];

          return !!devices && devices.filter(d => d.visible && d.id > -1).length;
        })
      })
    });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-media/select-room/select-room.component.ts